import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Conditional from '../Conditional';
import Dialog from '../Dialog';

const DialogList = ({ dialogs, onDismiss }) => {
  const handleOnHide = dialog => () => {
    onDismiss(dialog);
  };

  const handleOnConfirm = dialog => () => {
    dialog.onConfirm(dialog.id);
  };

  const renderDialog = dialog => (
    <Dialog
      dialogId={dialog.id}
      key={dialog.id}
      onHide={handleOnHide(dialog)}
      onConfirm={handleOnConfirm(dialog)}
      show={dialog.show}
      showButtons={dialog.showButtons}
      title={dialog.title}
    >
      {dialog.body}
    </Dialog>
  );

  return (
    <Conditional condition={dialogs.length}>
      <div>{dialogs.map(renderDialog)}</div>
    </Conditional>
  );
};

DialogList.propTypes = {
  dialogs: PropTypes.arrayOf(PropTypes.shape({
    body: PropTypes.node,
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    onConfirm: PropTypes.func,
    show: PropTypes.bool,
    showButtons: PropTypes.bool,
    title: PropTypes.string
  })).isRequired,
  onDismiss: PropTypes.func
};

DialogList.defaultProps = {
  onDismiss: () => {}
};

const mapStateToProps = ({ dialogs }) => ({ dialogs });

export default connect(mapStateToProps, null)(DialogList);



// WEBPACK FOOTER //
// ./src/components/DialogList/index.js